import { memo } from "react"

import { cn } from "@productlane/lib/src/cn"
import { FormTextarea, typographyVariants } from "@productlane/ui"

interface Props {
	name: string
	placeholder: string
	readOnly: boolean
}

// Linear's project description is a plain-text summary, not a markdown document,
// so anything typed here reaches Linear verbatim and markdown would show as
// syntax. Issue descriptions get the rich editor instead.
export const PlainDescriptionField = memo(
	({ name, placeholder, readOnly }: Props) => (
		<FormTextarea
			variant="borderless"
			name={name}
			placeholder={placeholder}
			minRows={1}
			readOnly={readOnly}
			className="no-scrollbar mt-4 w-full"
			inputClassName={cn(
				typographyVariants({ variant: "editor" }),
				"w-full text-[16px] leading-[1.5] tracking-tight",
			)}
		/>
	),
)
